import React, { Fragment } from "react";
import {
    Datagrid,
    ImageField,
    List,
    ListProps,
    NumberField,
    RichTextField,
    TextField,
    ReferenceField
} from "react-admin";
import Nutrition from "./Nutrition";
import ImagesFieldList from "./ImagesFeild";

const ProductList = (props: ListProps) => {
    return (
        <Fragment>
            <List
                {...props}
                sort={{ field: 'title', order: 'ASC' }}
                perPage={10}
            >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <TextField source="name_en" />
                    <TextField source="barcode" />
                    <ReferenceField source="category_id" reference="categories"><TextField source="name_en" /></ReferenceField>
                    {/* <ImagesFieldList/> */}
                    <ImageField source="featured_image" />
                    <NumberField source="active" label="Active" />
                </Datagrid>
            </List>
        </Fragment>
    )
}

export default ProductList;